import { useContext } from 'react';
import { FeatureServicesProvider } from '../provider/feature-services-provider';
import { useCarlineStore } from '../store/carline';
import { ActiveTabKeys, } from '../types/tracking';
const serializeBaseEvent = (eventInfo, attributes, additionalObjects, updatePageInfo, selectedTab) => {
    return Object.assign(Object.assign({ event: {
            eventInfo,
            attributes: Object.assign({ componentName: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.split(' ').join('-'), label: '', clickID: '', currentURL: '', targetURL: '', elementName: '', value: '', pos: '' }, attributes),
        } }, (additionalObjects ? { componentUpdate: additionalObjects } : {})), (updatePageInfo ? { pageUpdate: updatePageInfo } : {}));
};
export const useTracking = () => {
    const { trackingService, loggerService } = useContext(FeatureServicesProvider);
    const { appConfig } = useCarlineStore();
    const handleUpdateComponentInfo = (componentInfo) => {
        if (!trackingService) {
            loggerService === null || loggerService === void 0 ? void 0 : loggerService.error('Tracking service not found');
            return;
        }
        if (trackingService) {
            trackingService.updateComponent(componentInfo);
        }
    };
    const handleTrackEvent = (event) => {
        if (!trackingService) {
            loggerService === null || loggerService === void 0 ? void 0 : loggerService.error('Tracking service not found');
            return;
        }
        if (loggerService) {
            loggerService.info('Tracking event:', event.eventInfo.eventName, event);
        }
        trackingService.track(serializeBaseEvent(event.eventInfo, event.attributes, event.additionalObjects, event.updatePageInfo, ActiveTabKeys[(appConfig === null || appConfig === void 0 ? void 0 : appConfig.selectedTab) || 'standardEquipment']));
    };
    return {
        baseTrackingEventName: `configurator (${ActiveTabKeys[(appConfig === null || appConfig === void 0 ? void 0 : appConfig.selectedTab) || 'standardEquipment']})`,
        handleTrackEvent,
        handleUpdateComponentInfo,
    };
};
